import { Component, OnInit } from '@angular/core';

interface InboxMail {
  id: number;

  sender: string;

  email: string;

  to: string;

  subject: string;

  preview: string;

  body: string;

  bodySecond?: string;

  time: string;

  fullDate: string;

  unread: boolean;

  starred: boolean;

  hasAttachment: boolean;

  category?: string;

  avatarClass?: string;
}
@Component({
  selector: 'pm-inbox',
  templateUrl: './inbox.component.html',
  styleUrls: ['./inbox.component.css']
})
export class InboxComponent implements OnInit {

  selectedFolder = 'Inbox';

  searchText = '';

  selectedMail: InboxMail | null = null;


  mockMails: InboxMail[] = [

    {
      id: 1,
      sender: 'Sarah Johnson',
      email: 'sarah.johnson@demo.com',
      to: 'me',
      subject: 'Patient eligibility verification completed',
      preview:
        'The eligibility verification for Amanda Wilson has been completed successfully.',
      body:
        'The eligibility verification for Amanda Wilson has been completed successfully. All insurance details have been reviewed and the verification is now available in the patient record.',
      time: '10:42 AM',
      fullDate: 'September 8, 2026, 10:42 AM',
      unread: true,
      starred: true,
      hasAttachment: true,
      category: 'Verification',
      avatarClass: 'avatar-blue'
    },

    {
      id: 2,
      sender: 'Michael Brown',
      email: 'michael.brown@demo.com',
      to: 'me',
      subject: 'Member ID requires review',
      preview:
        'The insurance portal could not locate the patient using the supplied Member ID.',
      body:
        'The insurance portal could not locate the patient using the supplied Member ID. Please verify the Member ID and subscriber details before attempting the verification again.',
      time: '9:25 AM',
      fullDate: 'September 8, 2026, 9:25 AM',
      unread: true,
      starred: false,
      hasAttachment: false,
      category: 'Patients',
      avatarClass: 'avatar-purple'
    },

    {
      id: 3,
      sender: 'EVM System',
      email: 'notifications@evm.demo',
      to: 'me',
      subject: 'Daily verification summary',
      preview:
        'Your daily verification summary is ready. 128 accounts were processed today.',
      body:
        'Your daily verification summary is ready. A total of 128 accounts were processed today, with 116 successfully verified and 12 requiring additional review.',
      bodySecond:
        'You can review the account details from the dashboard.',
      time: '8:10 AM',
      fullDate: 'September 8, 2026, 8:10 AM',
      unread: false,
      starred: false,
      hasAttachment: false,
      category: 'System',
      avatarClass: 'avatar-cyan'
    },

    {
      id: 4,
      sender: 'Emily Davis',
      email: 'emily.davis@demo.com',
      to: 'me',
      subject: 'Insurance details updated',
      preview:
        'The insurance information for patient Robert Miller has been updated.',
      body:
        'The insurance information for Robert Miller has been updated. The latest group number, payer information and coverage details are now available.',
      time: 'Yesterday',
      fullDate: 'September 7, 2026, 6:35 PM',
      unread: false,
      starred: true,
      hasAttachment: false,
      category: 'Patients',
      avatarClass: 'avatar-green'
    },

    {
      id: 5,
      sender: 'Daniel Wilson',
      email: 'daniel.wilson@demo.com',
      to: 'me',
      subject: 'Verification assigned to you',
      preview:
        'Three additional patient verifications have been assigned to your queue.',
      body:
        'Three additional patient verifications have been assigned to your queue. Please review them when available.',
      time: 'Yesterday',
      fullDate: 'September 7, 2026, 4:18 PM',
      unread: true,
      starred: false,
      hasAttachment: false,
      category: 'Verification',
      avatarClass: 'avatar-orange'
    },

    {
      id: 6,
      sender: 'Olivia Martinez',
      email: 'olivia.martinez@demo.com',
      to: 'me',
      subject: 'Unable to verify subscriber information',
      preview:
        'Subscriber information did not match the insurance portal records.',
      body:
        'Subscriber information did not match the insurance portal records. Please confirm the subscriber name and date of birth before retrying.',
      time: 'Mon',
      fullDate: 'September 7, 2026, 11:05 AM',
      unread: false,
      starred: false,
      hasAttachment: false,
      category: 'Verification',
      avatarClass: 'avatar-pink'
    },

    {
      id: 7,
      sender: 'EVM Support',
      email: 'support@evm.demo',
      to: 'me',
      subject: 'Platform maintenance completed',
      preview:
        'Scheduled maintenance has been completed and all EVM services are operational.',
      body:
        'Scheduled maintenance has been completed successfully. All EVM services are operational and users may continue their normal workflow.',
      time: 'Sep 6',
      fullDate: 'September 6, 2026, 7:00 AM',
      unread: false,
      starred: false,
      hasAttachment: false,
      category: 'System',
      avatarClass: 'avatar-dark'
    }

  ];


  constructor() {

    if (this.mockMails.length > 0) {

      this.selectedMail = this.mockMails[0];

    }

  }

  ngOnInit(): void {
    
  }


  get filteredMails(): InboxMail[] {

    let mails = this.mockMails;


    if (this.selectedFolder === 'Starred') {

      mails = mails.filter(mail => mail.starred);

    }


    const search = this.searchText.trim().toLowerCase();


    if (!search) {

      return mails;

    }


    return mails.filter(mail =>

      mail.sender.toLowerCase().includes(search) ||

      mail.subject.toLowerCase().includes(search) ||

      mail.preview.toLowerCase().includes(search)

    );

  }


  selectMail(mail: InboxMail): void {

    this.selectedMail = mail;

    mail.unread = false;

  }


  selectFolder(folder: string): void {

    this.selectedFolder = folder;

  }


  toggleStar(
    event: MouseEvent,
    mail: InboxMail
  ): void {

    event.stopPropagation();

    mail.starred = !mail.starred;

  }


  getInitials(name: string): string {

    return name
      .split(' ')
      .map(value => value.charAt(0))
      .slice(0, 2)
      .join('')
      .toUpperCase();

  }


  trackByMailId(
    index: number,
    mail: InboxMail
  ): number {

    return mail.id;

  }

}
